export default "__VITE_ASSET__QfINl0Q8__"